import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {AbsoluteFill, Easing, interpolate, useCurrentFrame} from 'remotion';

export const ExploreBackgroundRemovalRecording20261027Composition = () => {
	const frame = useCurrentFrame();

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={421}
			style={{
				width: 1704,
				height: 1440,
			}}
		>
			<Video
				src="https://remotion.media/explore-remotion/background-removal-source-2026-10-27-f4022a48861a.mp4"
				durationInFrames={421}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[5, 27, 28, 77, 322, 335, 338, 339],
					[
						'auto',
						'ns-resize',
						'auto',
						'default',
						'auto',
						'default',
						'row-resize',
						'auto',
					],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 66, 291, 377, 383],
						[
							2.8323370776157475, 2.5491033698541727, 2.8323370776157475,
							2.5491033698541727, 2.8323370776157475,
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							5, 6, 7, 8, 9, 10, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
							24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
							42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
							58, 59, 60, 61, 62, 70, 71, 72, 73, 74, 76, 77, 78, 79, 80, 81,
							82, 83, 84, 85, 86, 87, 88, 89, 91, 92, 93, 94, 111, 112, 113,
							114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126,
							127, 128, 129, 130, 131, 132, 134, 135, 136, 137, 139, 140, 141,
							142, 143, 144, 145, 146, 147, 148, 149, 151, 152, 153, 154, 155,
							156, 157, 158, 159, 161, 162, 163, 164, 165, 166, 167, 168, 169,
							170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182,
							183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195,
							196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208,
							209, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222,
							223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235,
							236, 239, 240, 241, 249, 250, 251, 321, 322, 323, 324, 325, 326,
							327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339,
							340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352,
							353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365,
							366, 367, 368, 369, 370, 371, 372,
						],
						[
							'935.7776172841403px 2712.184028151267px',
							'946.1554773575917px 2690.742351368379px',
							'946.1554773575917px 2690.742351368379px',
							'982.1792645635171px 2610.540744041674px',
							'982.1792645635171px 2610.540744041674px',
							'1071.242989074481px 2437.6464803233093px',
							'1071.242989074481px 2437.6464803233093px',
							'1084.4310585921294px 1668.998878251917px',
							'1082.572337384944px 1561.7019838038016px',
							'1082.572337384944px 1561.7019838038016px',
							'1057.302580020591px 1465.4025231648661px',
							'1054.2710942422054px 1430.9608617483905px',
							'1054.2710942422054px 1418.9013015351045px',
							'1054.2710942422054px 1413.5353504310278px',
							'1053.9281159242128px 1407.7932295588303px',
							'1052.8106704365598px 1403.301319974799px',
							'1049.1817385558645px 1395.7115417121256px',
							'1045.8294020929054px 1389.6817616054827px',
							'1040.3860042718625px 1378.9387955806199px',
							'1035.5179249197106px 1370.9175284662783px',
							'1035.5179249197106px 1370.9175284662783px',
							'1023.1707054719793px 1355.273291639135px',
							'945.5248398051539px 1257.7568111621617px',
							'917.6772131475022px 1208.235167570724px',
							'899.4329793936414px 1147.6275796364307px',
							'893.8457519553759px 1106.702521628225px',
							'893.060220969006px 1085.9799929314504px',
							'893.060220969006px 1062.8898074588565px',
							'893.060220969006px 1049.0932280221891px',
							'893.1155400525531px 1040.9723865574626px',
							'893.1597953193909px 1038.8038784824132px',
							'893.1597953193909px 1037.5426033775373px',
							'893.1597953193909px 1037.000476358775px',
							'893.1597953193909px 1036.9672849086467px',
							'893.1597953193909px 1036.9672849086467px',
							'893.1597953193909px 1037.8413264286921px',
							'893.1597953193909px 1046.681315979532px',
							'893.1597953193909px 1058.873641993331px',
							'893.2925611199041px 1063.387679210781px',
							'894.7419211088403px 1069.395331684005px',
							'896.71128048312px 1074.5731979040213px',
							'900.6499992316794px 1081.963827465925px',
							'900.6831906818077px 1082.0744656330194px',
							'900.7827650321926px 1082.3731886841742px',
							'901.6899980023665px 1085.0948875946956px',
							'903.7257402769028px 1090.6489235828326px',
							'905.6397805676353px 1096.3025339213548px',
							'908.826159779953px 1104.799545154202px',
							'910.8508382377798px 1110.8735805276826px',
							'911.6363692241498px 1115.122086144106px',
							'912.0567942591084px 1119.8242082456168px',
							'912.4219002105199px 1126.2854772039277px',
							'912.4219002105199px 1130.3348341195815px',
							'912.4219002105199px 1131.7841941085176px',
							'912.4219002105199px 1132.1050447930913px',
							'912.4219002105199px 1132.1050447930913px',
							'912.4219002105199px 1133.012277763265px',
							'912.4219002105199px 1137.7918465817415px',
							'912.4219002105199px 1141.2437573950858px',
							'912.4219002105199px 1143.6777970711619px',
							'912.4219002105199px 1143.6777970711619px',
							'912.4219002105199px 1147.0080059007023px',
							'912.4219002105199px 1147.0080059007023px',
							'913.0746653963766px 1154.608847980085px',
							'913.0746653963766px 1154.608847980085px',
							'913.5504095148824px 1158.1271416936859px',
							'913.5504095148824px 1158.1271416936859px',
							'913.9487069164221px 1165.7501114064878px',
							'913.9708345498409px 1169.2241498532508px',
							'913.9708345498409px 1169.2241498532508px',
							'914.2363661508674px 1171.3262750280437px',
							'914.656791185826px 1173.7271232539915px',
							'914.656791185826px 1173.7271232539915px',
							'915.0993438542034px 1177.3228636845583px',
							'915.0993438542034px 1177.3228636845583px',
							'915.3316840051017px 1180.0445625950797px',
							'915.3316840051017px 1180.0445625950797px',
							'915.3538116385205px 1180.509242896876px',
							'915.3538116385205px 1180.509242896876px',
							'915.3538116385205px 1180.2215836624307px',
							'915.3538116385205px 1180.2215836624307px',
							'915.265301104845px 1177.4888209351998px',
							'915.265301104845px 1177.4888209351998px',
							'915.0661524040752px 1171.082871060436px',
							'915.0661524040752px 1171.082871060436px',
							'914.8227484364676px 1168.4607465002996px',
							'914.7342379027921px 1163.249688830155px',
							'914.7342379027921px 1163.249688830155px',
							'914.3470043179618px 1156.6999093381687px',
							'914.3470043179618px 1156.6999093381687px',
							'914.0814727169353px 1153.0377860073452px',
							'914.0814727169353px 1153.0377860073452px',
							'913.9265792830032px 1145.558645911766px',
							'913.3844522642408px 1137.9688676490925px',
							'913.3844522642408px 1137.9688676490925px',
							'913.3844522642408px 1129.5271754997925px',
							'913.3844522642408px 1129.5271754997925px',
							'912.654240361418px 1120.996972816817px',
							'912.654240361418px 1120.996972816817px',
							'912.1674324262028px 1113.573151804785px',
							'912.1674324262028px 1113.573151804785px',
							'912.0125389922707px 1108.2072007007084px',
							'912.0125389922707px 1108.2072007007084px',
							'911.3155185395761px 1098.869339397944px',
							'911.3155185395761px 1098.869339397944px',
							'911.260199456029px 1093.7689198948938px',
							'911.260199456029px 1093.7689198948938px',
							'911.260199456029px 1092.1204112051878px',
							'911.260199456029px 1090.6931788496704px',
							'911.260199456029px 1084.8514836270879px',
							'911.260199456029px 1083.4131874548611px',
							'911.260199456029px 1083.4131874548611px',
							'911.536794873765px 1080.2710635093813px',
							'911.536794873765px 1080.2710635093813px',
							'911.536794873765px 1076.918727046422px',
							'911.536794873765px 1076.918727046422px',
							'911.6916883076971px 1075.4583032407763px',
							'911.6916883076971px 1075.4583032407763px',
							'911.6916883076971px 1073.1017102816663px',
							'911.6916883076971px 1071.8404351767906px',
							'911.6916883076971px 1071.8404351767906px',
							'911.6916883076971px 1069.4506507675524px',
							'911.6916883076971px 1069.4506507675524px',
							'911.6916883076971px 1067.0498025416045px',
							'911.6916883076971px 1067.0498025416045px',
							'911.3819014398329px 1064.2395930974076px',
							'911.3819014398329px 1064.2395930974076px',
							'910.6959448038477px 1057.9442813897383px',
							'910.6959448038477px 1057.9442813897383px',
							'910.6184980868817px 1054.6362001936168px',
							'910.4193493861119px 1053.19790402139px',
							'910.4193493861119px 1053.19790402139px',
							'910.4193493861119px 1051.4940762481367px',
							'910.4193493861119px 1049.314504356378px',
							'910.4193493861119px 1047.035358114234px',
							'910.2644559521797px 1044.9664243895693px',
							'910.1759454185043px 1042.7979163145196px',
							'910.1759454185043px 1038.9698357330547px',
							'910.1759454185043px 1038.9698357330547px',
							'910.1538177850854px 1036.11537102202px',
							'909.9214776341872px 1034.5111175991517px',
							'909.9214776341872px 1034.5111175991517px',
							'909.9214776341872px 1030.6277179341396px',
							'909.9214776341872px 1026.611552468614px',
							'909.9214776341872px 1024.863469428523px',
							'910.1316901516665px 1023.2038969221077px',
							'910.1870092352136px 1021.7324092997526px',
							'910.1870092352136px 1019.6302841249596px',
							'910.1870092352136px 1018.2141155861518px',
							'910.1870092352136px 1015.127310724219px',
							'910.1870092352136px 1013.4124191342563px',
							'910.1870092352136px 1013.4124191342563px',
							'910.1870092352136px 1011.8192295280975px',
							'910.1870092352136px 1010.1817846551008px',
							'910.1870092352136px 1009.1528497011233px',
							'909.9325414508967px 1007.9358298630852px',
							'909.8882861840589px 1005.3468967530771px',
							'909.8882861840589px 1005.3468967530771px',
							'909.8882861840589px 1004.7051953839298px',
							'909.8882861840589px 1003.8864729474315px',
							'909.8882861840589px 1003.2115801281559px',
							'909.8882861840589px 1003.2115801281559px',
							'909.8882861840589px 1000.323923966993px',
							'909.8882861840589px 1000.323923966993px',
							'909.8882861840589px 999.3834995466908px',
							'909.8882861840589px 997.6354165065999px',
							'909.8882861840589px 994.2830800436406px',
							'909.8882861840589px 992.6677628040629px',
							'909.8882861840589px 992.6677628040629px',
							'909.8882861840589px 991.1852113649984px',
							'909.8882861840589px 991.1852113649984px',
							'909.8882861840589px 988.2422361202882px',
							'909.8882861840589px 986.5052168969067px',
							'909.8882861840589px 986.5052168969067px',
							'910.1648816017948px 985.1333036249366px',
							'910.1648816017948px 985.1333036249366px',
							'910.1648816017948px 983.9052199701891px',
							'910.1648816017948px 983.2745824177513px',
							'910.1648816017948px 982.3673494475775px',
							'910.1648816017948px 981.7145842617207px',
							'910.1648816017948px 980.7630960247092px',
							'910.1648816017948px 980.7630960247092px',
							'909.8772223673494px 979.2694807689353px',
							'909.9878605344438px 977.0124621602102px',
							'910.1980730519231px 975.6626765216589px',
							'910.1980730519231px 974.9214008021268px',
							'910.1980730519231px 974.2354441661416px',
							'910.1980730519231px 973.992040198534px',
							'910.1980730519231px 973.3392750126773px',
							'910.1980730519231px 973.1179986784886px',
							'910.1980730519231px 972.3877867756657px',
							'910.1980730519231px 971.7682130399373px',
							'910.1980730519231px 971.2703412880127px',
							'910.1980730519231px 970.9273629700201px',
							'910.0874348848288px 970.3520445011294px',
							'909.9767967177344px 969.8873641993331px',
							'909.9767967177344px 969.5001306145028px',
							'909.9767967177344px 969.2345990134763px',
							'909.9767967177344px 969.1682161132197px',
							'909.9767967177344px 969.1682161132197px',
							'909.9767967177344px 968.9801312291593px',
							'909.9767967177344px 968.7477910782611px',
							'909.9767967177344px 968.7477910782611px',
							'909.6780736665796px 968.7477910782611px',
							'909.5563716827758px 968.7477910782611px',
							'909.5563716827758px 968.7477910782611px',
							'911.160625105644px 969.6660878651444px',
							'922.1469950981145px 982.1460731133888px',
							'937.492508874103px 1014.2200777540452px',
							'943.0022895954023px 1073.7212840173947px',
							'943.500161347327px 1195.1909276702982px',
							'943.500161347327px 1195.1909276702982px',
							'943.500161347327px 1290.3286875547428px',
							'941.8737802910398px 1507.3122608602118px',
							'941.8737802910398px 1507.3122608602118px',
							'932.7240038723359px 1618.6474484072714px',
							'919.7350830554574px 1718.0005224580113px',
							'910.5631790033345px 1816.0259385036188px',
							'908.7819045131153px 1884.4777724849025px',
							'908.7819045131153px 1938.5355809272094px',
							'908.7819045131153px 1999.818061680778px',
							'908.7819045131153px 1999.818061680778px',
							'908.7819045131153px 2024.8886703443613px',
							'912.0789218925273px 2109.9804846566376px',
							'914.0593450835164px 2145.705548811408px',
							'914.0593450835164px 2145.705548811408px',
							'914.0593450835164px 2173.15487806752px',
							'914.0593450835164px 2202.728460131844px',
							'915.1214714876223px 2258.290947646634px',
							'915.1214714876223px 2284.7334695821874px',
							'915.8516833904451px 2339.7427662615055px',
							'915.8516833904451px 2339.7427662615055px',
							'907.9742458933264px 2425.8745793444687px',
							'897.6406410867127px 2483.5945111175993px',
							'894.3436237073006px 2537.4089155922984px',
							'894.3436237073006px 2569.604622216759px',
							'894.3436237073006px 2569.604622216759px',
							'894.3436237073006px 2612.8420179172367px',
							'894.3436237073006px 2612.8420179172367px',
							'894.7529849255498px 2639.0190082517634px',
							'894.7529849255498px 2639.0190082517634px',
							'896.4346850653841px 2640.6232616746315px',
							'899.7648938949245px 2642.4930466985265px',
							'901.8227638028796px 2643.59942836947px',
							'906.1487161362693px 2645.9338936951613px',
							'906.1487161362693px 2645.9338936951613px',
							'916.581895293268px 2655.083670113865px',
							'916.581895293268px 2655.083670113865px',
							'923.0542280682884px 2672.3432241805863px',
							'923.0542280682884px 2672.3432241805863px',
							'924.9350769088925px 2680.242789311124px',
							'926.9929468168477px 2700.279361371913px',
							'928.3537962721084px 2713.246154555373px',
							'931.6508136515205px 2728.3703919971726px',
							'931.6508136515205px 2728.3703919971726px',
							'933.0116631067812px 2732.508259446502px',
							'933.0891098237472px 2732.7295357806906px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};
